import { v4 as uuidv4 } from 'uuid'
import { ProductiveAnimalDTO } from 'src/dto/animal.dto'

export interface AnimalProductiveParams {
  idFazenda: string
  idAnimal: string
  nome: string
  peso: number
  idadeDias: number
  idTransacao?: string
  idProdutivo?: string
  gpm?: number | null
  gpd?: number | null
  inter?: number | null
  data?: string
  idLote?: string | null
  idLocal?: string | null
  pesoAnterior?: number | null
  perimetro?: number | null
}

export class AnimalProductive implements ProductiveAnimalDTO {
  idFazenda: string
  idAnimal: string
  idProdutivo: string
  idTransacao: string
  nome: string
  data: string
  peso: number
  pesoAnterior: number | null
  idadeDias: number
  inter: number | null
  gpd: number | null
  gpm: number | null
  idLote: string | null
  idLocal: string | null
  perimetro: number | null
  sync = false
  delete = false
  acao = 'Atualizacao'
  tela = 'cadastroAnimal'

  constructor({
    idFazenda,
    idAnimal,
    nome = '',
    peso = 0,
    idadeDias = 0,
    gpm = null,
    gpd = null,
    inter = null,
    idTransacao = uuidv4(),
    idProdutivo = uuidv4(),
    data = new Date().toISOString(),
    idLote = null,
    idLocal = null,
    pesoAnterior = null,
    perimetro = null
  }: AnimalProductiveParams) {
    this.idFazenda = idFazenda
    this.idAnimal = idAnimal
    this.idProdutivo = idProdutivo
    this.idTransacao = idTransacao
    this.nome = nome
    this.data = data
    this.peso = peso
    this.pesoAnterior = pesoAnterior
    this.idadeDias = idadeDias
    this.inter = inter
    this.gpd = gpd
    this.gpm = gpm
    this.idLote = idLote
    this.idLocal = idLocal
    this.perimetro = perimetro
  }
}
